import { CNT_KEY, formatPhoneNumber } from "../../components/ContactForm/helpers";
import { DER_KEY } from "../../components/DERSystemInfo/helpers";

export const buildPreAppRequest = (projectData,sectionData,appType,userData,custAcctData,actionType) =>{
  const customer = sectionData.find((x) => x?.id === 1)?.data;
  const applicant = sectionData.find((x) => x?.id === 2)?.data;
  const sysData = sectionData.find((x) => x?.id === 3)?.data;
  
    return {
        "programId": projectData?.programId ?? "",
        "projectId": projectData?.projectId ?? "",
        "status": "",
        "appType": projectData?.appType ?? appType,
        "actionType":actionType,
        "enrolment": {
          "appNb": "",
          "applicantInformation": {},
          "contractor": {},
          "customer": {
            "accountNb": "",
            "premiseNb": "",
            "ezId": "",
            "opcoName": "",
            "stateCode": "",
            "jurisdiction": ""
          },
          "customerPrograms": []
        },
        "preapp": {
          "appNb": "",
          "customerAttributes": {
              ...custAcctData?.serviceAddress,
              "customerNb": "",
              "premiseNb": custAcctData?.premiseNb??'',
              "meterNb": custAcctData?.meterSerialNb,
              "opcoName": custAcctData?.opcoName,
              "opcoCo": "",
              "stateCode":"",
              "jurisdiction":custAcctData?.jurisdictionCode ?? '',
              "accountNb": customer?.[CNT_KEY.CONTYPE]==="accNo"? customer?.[CNT_KEY.CONID]:"",
              "ezId": customer?.[CNT_KEY.CONTYPE]!=="accNo"? customer?.[CNT_KEY.CONID]:"",
              [CNT_KEY.LAT]: custAcctData?.latitude || customer?.[CNT_KEY.LAT] ,
              [CNT_KEY.LONG]: custAcctData?.longitude || customer?.[CNT_KEY.LONG],
              "contactType": "Customer",
              "contactId": ""
          },
          "poiServiceAddress": {
            ...customer,
            ...custAcctData?.serviceAddress,
              [CNT_KEY.ZIP]: custAcctData?.serviceAddress?.zipCode?.substring(0,5) || customer?.[CNT_KEY.ZIP],
              "contactType": "POI",
              "contactId": ""
          },
          "applicant": {
              ...applicant,
              "contactType": "Applicant",
              "contactId": ""
          },
          "appOwner": {
            "firstName": userData?.profile?.firstName,
            "lastName": userData?.profile?.lastName,
            "email": userData?.profile?.email,
            "address1": userData?.profile?.streetAddress,
            "address2": userData?.profile?.streetAddress2,
            "city": userData?.profile?.city,
            "state": userData?.profile?.state,
            "zipCode":  userData?.profile?.zipCode,
            "contactNo": "",
            "mobileNo":  userData?.profile?.mobilePhone,
            "companyName": userData?.profile?.companyName,
            "contactType": "ApplicationOwner",
            "contactId": "",
            "aepUserId":userData?.profile?.login ? userData?.profile?.login.match(/^.+(?=@)/)[0]:null
          },
          "appPrjctNmCalc": customer?.[CNT_KEY.PRJ_NM],
          "preAppDetails":sysData.map((device) =>buildSysData(device))
      }
    }
}

export const reBuildCntGenData = (apiData) => {
  if(apiData){
    return {
      ...apiData,
      [CNT_KEY.VALIDZIP]: apiData?.zipCode ? true :false,
      [CNT_KEY.MOBILE]: formatPhoneNumber(apiData?.mobileNo || apiData?.contactNo), 
    }
  }
}

const buildSysData = (device)=>{
    return {
    "aepPreTotalACCapacity": device?.[DER_KEY.CAPACITY],
    "aepTotalGenCapacity":  device?.[DER_KEY.DEVICE] ==="Generation Devices" ? device?.[DER_KEY.CAPACITY]:0,
    "aepTotalStoragePower": 0,
    "aepTotalStorageCap": device?.[DER_KEY.DEVICE] ==="Energy Storage Devices" ? device?.[DER_KEY.CAPACITY]:0 ,
    "deviceType": device?.[DER_KEY.DEVICE],
    "energyType": device?.[DER_KEY.ENERGY],
    "device": device?.[DER_KEY.ESD_G],
    "casAppPreType": "",
    "origSubmitTs": "",
    "opcoName": "",
    "casGenStandAloneInd":"",
    "genSysPhaseType": "",
    "fuelCd": "",
    "genTypeFuelCdOther": "",
    "genSupBtryInd": "",
    "genSysInvInd": "",
    "esType": "",
    "genAllRotatingTypeCd": ""
    }
  }


export const reBuildCustomerData = (apiData) => {
  const customerData  = apiData?.customer
  if(customerData){
    return {
      ...customerData,
      [CNT_KEY.PRJ_NM]: apiData?.projectName ?? '',
      [CNT_KEY.VALIDCON]:  true,
      [CNT_KEY.HVCONN]:(customerData?.accountNb || customerData?.ezId) ? 'yes' :'no',
      [CNT_KEY.VALIDZIP]: customerData?.zipCode ? true :false,
      [CNT_KEY.MOBILE]: formatPhoneNumber(customerData?.mobileNo || customerData?.contactNo),
      [CNT_KEY.CONID]: customerData?.accountNb  ||  customerData?.ezId,
      [CNT_KEY.CONTYPE]: customerData?.accountNb ? 'accNo' : customerData?.ezID ? 'ezId':''
    }
  }
}